var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications"},_vm._l((_vm.notifications),function(notification){return _c('notification',_vm._b({key:notification.uuid,on:{"remove":function($event){return _vm.removeItem(notification.uuid)}}},'notification',notification,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }